import { render, staticRenderFns } from "./SummaryTable.vue?vue&type=template&id=226cc52a&scoped=true&"
import script from "./SummaryTable.vue?vue&type=script&lang=js&"
export * from "./SummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTable.vue?vue&type=style&index=0&id=226cc52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226cc52a",
  null
  
)

export default component.exports